export default "__VITE_ASSET__Ce0ODe3X__"